import React, { ReactElement } from 'react';

const AppointmentCollapseDetail: React.FC<{ title: string | ReactElement; children: string | ReactElement }> = ({
  title,
  children,
}) => (
  <div className='pt-4 first:pt-0'>
    <div className='text-lg font-semibold'>{title}</div>
    <div className='pt-3 pl-2 flex items-center'>{children}</div>
  </div>
);

export default React.memo(AppointmentCollapseDetail);
